import { render, staticRenderFns } from "./QuickActions.vue?vue&type=template&id=99163bc0"
import script from "./QuickActions.vue?vue&type=script&lang=js"
export * from "./QuickActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99163bc0')) {
      api.createRecord('99163bc0', component.options)
    } else {
      api.reload('99163bc0', component.options)
    }
    module.hot.accept("./QuickActions.vue?vue&type=template&id=99163bc0", function () {
      api.rerender('99163bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/offcanvas/QuickActions.vue"
export default component.exports